<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <dashboard-core-settings />
  </v-app>
</template>

<script>
import VueCookies from 'vue-cookies'
import Vue from 'vue'
Vue.use(VueCookies)
export default {
  name: 'DashboardIndex',
  components: {
    DashboardCoreAppBar: () => import('./components/core/AppBar'),
    DashboardCoreDrawer: () => import('./components/core/Drawer'),
    DashboardCoreSettings: () => import('./components/core/Settings'),
    DashboardCoreView: () => import('./components/core/View'),
  },

  data: () => ({
    expandOnHover: false,
  }),
  created() {
    // //console.log(VueCookies.isKey('user'));
    // //console.log(VueCookies.isKey('home'));
    // //console.log(VueCookies.isKey('admin'));
    // this.showError = false
    // this.successBool = false
    if (!VueCookies.isKey('user')) {
      this.$router.push('/Login')
    }
  },
}
</script>
